import { Injectable, signal, inject } from '@angular/core'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { UserReviewClient } from 'src/app/shared/services/ppv.api'

@Injectable({ providedIn: 'root' })
export class GlobalAdminService {
   private authMgr = inject(AuthManager)
   private userReviewClient = inject(UserReviewClient)

   isGlobalAdmin = signal<boolean>(false)
   isReportingAdmin = signal<boolean>(false)

   constructor() {
      this.authMgr.getCurrentUser().subscribe((user) => {
         this.userReviewClient.getAdminUsers().subscribe({
            next: (admins) => {
               const match = admins.find((a) => {
                  return a.userId === user.id.toString()
               })
               this.isGlobalAdmin.set(!!match)
               this.isReportingAdmin.set(match?.accessLevel === 'SuperAdmin')
            },
         })
      })
   }
}
